export default __webpack_public_path__ + "static/carousel-12-8597faa05d49e807720009d318430100.jpg";